export default __webpack_public_path__ + "static/renault-duster-876b8f71e9204947220cf0f5754918d8.jpg";